import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Card } from '@thd-olt-component-react/core-ui';
import { UserListsCarousel } from '@thd-olt-component-react/user-lists';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const UserListPropTypes = {
  id: string,
};

const UserListDefaultProps = {
  id: undefined,
};

export function CustomRenderedUserList({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  function UserList({ id }) {
    return (
      <QueryProvider key={id} cacheKey={id}>
        <Hydrator
          id="userList-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <Card>
            <UserListsCarousel />
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  }

  UserList.propTypes = UserListPropTypes;
  UserList.defaultProps = UserListDefaultProps;

  return UserList;
}
